export interface AppState {
	isLoading: boolean;
	loadingText?: string[];
	pageError?: PageError;
	inlineErrors?: { [key: string]: string };
}

export interface PageError {
	status: number;
	title: string;
	body: string;
}

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_CONTINUE_LOADER = "SHOW_CONTINUE_LOADER";
export const SET_PAGE_ERROR = "SET_PAGE_ERROR";
export const SET_INLINE_ERRORS = "SET_INLINE_ERRORS";
export const CLEAR_INLINE_ERRORS = "CLEAR_INLINE_ERRORS";

interface ShowLoaderAction {
	type: typeof SHOW_LOADER;
	payload?: string[];
}
interface HideLoaderAction {
	type: typeof HIDE_LOADER;
	payload?: undefined;
}

interface SetPageErrorAction {
	type: typeof SET_PAGE_ERROR;
	payload: PageError | undefined;
}
interface SetInlineErrorAction {
	type: typeof SET_INLINE_ERRORS;
	payload: { [key: string]: string };
}

interface ClearInlineErrorsAction {
	type: typeof CLEAR_INLINE_ERRORS;
	payload: string[] | undefined;
}

export type AppActionTypes =
	| ShowLoaderAction
	| HideLoaderAction
	| SetPageErrorAction
	| SetInlineErrorAction
	| ClearInlineErrorsAction;
